<template>
  <div class="home">
    <!-- intro animation -->
    <div class="loading-animation">
      <div class="loading-animation-graphic">
        <span></span>
        <svg
          width="299"
          height="47"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M292.103 39.7786c4.236-4.2302 6.897-10.056 6.897-16.4755C299 10.5013 288.392 0 275.46 0H.3284C10.8614 2.5975 18.733 12.0968 18.733 23.303c0 11.2434-7.8716 20.7057-18.4046 23.3032H275.46c6.447 0 12.332-2.5975 16.643-6.8277zm-32.836-16.4755c0-8.4603 6.897-15.288 15.443-15.288 8.547 0 15.444 6.8277 15.444 15.288 0 8.4604-6.897 15.2881-15.444 15.2881-8.546 0-15.443-6.8277-15.443-15.2881z"
            fill="#F9DF41"
          />
        </svg>
      </div>
      <div class="loading-animation-logo">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080">
          <g data-name="Layer 1">
            <path
              d="M946 54.2A62.8 62.8 0 00839 98.6v734a64.7 64.7 0 01125.6 0v-734a62.9 62.9 0 00-18.4-44.4zm-44.3 87.5a41.2 41.2 0 1141.2-41.2 41.2 41.2 0 01-41.2 41.3z"
              fill="#f9df41"
            />
            <circle cx="900.5" cy="848.3" r="41.2" />
            <path
              d="M997.3 389.9h74.4a2 2 0 012 1.9c2 21.4 37.8 37.3 86.8 37.3 49.8 0 84.1-12.6 84.1-30.1 0-19-42.7-26-106.5-33.6-72.2-8.5-137.3-38.6-137.3-107.2 0-74.3 72.8-113.6 157.6-113.6 90.2 0 157.7 53.6 159 122a2 2 0 01-2 2h-75.1a2.1 2.1 0 01-2.1-1.9c-2.2-18.6-36.4-32.4-80.5-32.4-46.2 0-77.8 11.2-77.8 27.4 0 16.8 39.3 25.9 105.8 33.6 68 7.7 137.4 34.3 137.4 105 0 76.5-73.6 118.5-164 118.5-94.4 0-162.6-56.3-164-126.8a2 2 0 012.2-2.1zM1729.8 361.9h-295.7a2.1 2.1 0 00-1.9 2.9c15.7 36.8 56.3 60.1 111.6 60.1 41.6 0 78.3-11.6 94.7-26.8a2 2 0 011.5-.5h84.4a2 2 0 012 2.8c-27.4 70.6-98.2 118.4-184.6 118.4-110.7 0-193.4-80.6-193.4-187S1431 144.5 1541 144.5s192.7 80 192.7 189.2a186.5 186.5 0 01-1.8 26.3 2 2 0 01-2 1.8zm-295-61h213.9a2.1 2.1 0 001.9-3c-15.1-36.8-57.7-59.4-109.6-59.4-51.2 0-92.4 23.3-108 59.4a2.1 2.1 0 001.9 3zM405.6 553.6v353.2a2 2 0 01-2 2.1h-75.8a2 2 0 01-2.1-2v-61.7a2 2 0 00-3.8-1c-27 45-71 73.1-126.5 73.1-98.1 0-172.4-80.6-172.4-187S97.3 543 195.4 543c55.4 0 99.4 28 126.5 73.2a2 2 0 003.8-1v-61.7a2 2 0 012-2h75.8a2 2 0 012 2zm-79.9 176.6c0-48.3-47-84.8-110-84.8S106.4 682 106.4 730.2 152.6 815 215.7 815s110-36.4 110-84.8zM812.3 732c0 106.7-73.6 187.3-172.6 187.3-55.5 0-100.1-28.6-126.7-73.8a2 2 0 00-3.8 1v195.6a2 2 0 01-2 2.1h-76a2 2 0 01-2-2v-487a2 2 0 012-2.2h76a2 2 0 012 2.1v62.3a2 2 0 003.8 1c26.6-45.2 71.2-73.8 126.7-73.8 99 0 172.6 80.7 172.6 187.4zm-82.8 0c0-48.4-47-85-110.1-85s-110.2 36.6-110.2 85 47 85 110.2 85 110.1-36.6 110.1-85zM1372.1 553.6v353.2a2 2 0 01-2 2.1h-75.8a2 2 0 01-2-2v-61.7a2 2 0 00-3.9-1c-27 45-71 73.1-126.5 73.1-98 0-172.4-80.6-172.4-187S1063.8 543 1162 543c55.5 0 99.5 28 126.5 73.2a2 2 0 003.8-1v-61.7a2 2 0 012.1-2h75.8a2 2 0 012 2zm-79.9 176.6c0-48.3-47-84.8-110-84.8S1073 682 1073 730.2s46.3 84.8 109.3 84.8 110-36.4 110-84.8zM1617.9 548.1V672a2 2 0 01-2.1 2c-84.8.6-130.3 31.9-130.3 88.3v144.3a2 2 0 01-2.1 2.1h-77a2 2 0 01-2.1-2v-353a2 2 0 012-2h77a2 2 0 012.2 2v79.5a2 2 0 004 1c28.3-54.4 72.2-87.3 126.2-88.2a2.1 2.1 0 012.2 2.1zM803 146v124a2 2 0 01-2 2c-84.9.6-130.4 31.9-130.4 88.3v144.3a2 2 0 01-2 2.1h-77a2 2 0 01-2.2-2v-353a2 2 0 012.1-2h77a2 2 0 012.1 2v79.5a2 2 0 004 1c28.3-54.4 72.2-87.3 126.3-88.2a2.1 2.1 0 012.1 2zM1793.8 646.5a2 2 0 00-2.1 2.1v121c0 24.2 15 35.6 46.2 35.6h49.9a2 2 0 012 2.1v98.3a2 2 0 01-2 2.1h-59.1c-78.3 0-118.9-37.7-118.9-113.1v-146a2 2 0 00-2-2.1h-66.4a2 2 0 01-2-2.1v-97.5a2 2 0 012-2.1h66.3a2 2 0 002.1-2.1v-76.4a2 2 0 011.5-2l77.7-21.6a2 2 0 012.6 2v98a2 2 0 002.1 2H1895a2 2 0 012 2.2v97.6a2 2 0 01-2 2z"
            />
          </g>
        </svg>
      </div>
    </div>

    <!-- programeaza o intalnire cta -->
    <div class="appointment-cta">
      <a
        href="#"
        @click.prevent="AppointmentForm(true)"
        @keydown.esc="AppointmentForm(false)"
        >{{ strings.programeaza_intalnire_cta }}
      </a>
    </div>

    <!-- programeaza o intalnire form -->
    <div class="appointment-form">
      <div class="appointment-form-shape mask-right">
        <div class="appointment-form-col">
          <a href="#" @click.prevent="AppointmentForm(false)">
            <svg
              width="47"
              height="44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke="#000"
                stroke-width="2"
                d="M2.6976 1.2835l43.0645 41.9334M44.3669 1.2835L1.3024 43.217"
              />
            </svg>
          </a>
        </div>
        <div class="appointment-form-col">
          <h5>{{ strings.programeaza_intalnire_headline }}</h5>
          <form
            class="form-styles form-styles--dark form-styles--w70"
            @submit="submitForm"
            action="#"
            method="post"
          >
            <input
              type="hidden"
              id="form_type"
              name="form_type"
              value="meeting"
            />
            <input
              type="text"
              v-model="user_name"
              name="user_name"
              value=""
              :placeholder="strings.programeaza_intalnire_nume"
              required
            />
            <input
              type="email"
              v-model="user_email"
              name="user_email"
              value=""
              :placeholder="strings.programeaza_intalnire_email"
              required
            />
            <input
              type="tel"
              v-model="user_phone"
              name="user_phone"
              pattern="[0-9]{4}[0-9]{3}[0-9]{3}"
              value=""
              :placeholder="strings.programeaza_intalnire_tel"
              required
            />
            <input
              type="date"
              id="date"
              v-model="user_date"
              name="user_date"
              min="2020-06-01"
              max="2030-12-31"
            />
            <textarea
              name="user_message"
              v-model="user_message"
              rows="8"
              cols="80"
              :placeholder="strings.programeaza_intalnire_mesaj"
              required
            ></textarea>
            <!-- newsletter -->
            <div class="gdpr_wrapper gdpr_wrapper--black">
              <input
                type="checkbox"
                id="label_subscribe_newsletter"
                name="label_subscribe_newsletter"
                value="true"
              />
              <span class="checkmark"></span>
              <label
                class="label_subscribe_newsletter"
                for="label_subscribe_newsletter"
                >{{ strings.subscribe_newsletter }}</label
              >
            </div>

            <!-- t&c -->
            <div class="gdpr_wrapper gdpr_wrapper--black">
              <input
                type="checkbox"
                id="label_accept_tc_1"
                name="label_accept_tc_1"
                value="Accept T&C"
                required
              />
              <span class="checkmark"></span>
              <label class="label_accept_tc_1" for="label_accept_tc_1">{{
                strings.programeaza_intalnire_accept_termeni
              }}</label>
            </div>
            <input
              type="submit"
              :value="strings.programeaza_intalnire_accept_trimite"
            />
          </form>
          <h6>{{ strings.programeaza_intalnire_thanks }}</h6>
        </div>
      </div>
    </div>

    <!-- Hero module -->
    <div
      id="hero"
      class="home-hero mask-right"
      :style="{
        backgroundImage: 'url(' + homepageImgs.homepage_2 + ')'
      }"
    >
      <div class="home-hero-content">
        <!-- desktop video -->
        <video autoplay muted loop v-if="!isMobile">
          <source src="../assets/content/hero-vid.mp4" type="video/mp4" />
        </video>

        <div
          class="home-hero-content-wrapper content"
          :class="{ active: isHeroActive }"
          v-observe-visibility="{
            callback: (isVisible, entry) =>
              visibilityChanged(isVisible, entry, 'isHeroActive'),
            intersection: {
              threshold: 0.3
            }
          }"
        >
          <h3>{{ strings.home_headline }}</h3>
          <h2>{{ strings.home_subheadline }}</h2>
          <router-link v-bind:to="'/project/fainari'">{{
            strings.home_cta
          }}</router-link>
        </div>
      </div>
    </div>

    <!-- Our Projects -->
    <div id="our-projects" class="section-wrapper section-wrapper--projects">
      <a
        href="#"
        class="button button--map button--map--m"
        @click.prevent="toggleMap()"
      ></a>
      <div
        class="our-projects-shadow mask-left"
        :class="{ active: maskL0 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskL0'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <h2>{{ strings.home_proiectele_noastre }}</h2>
        <a
          href="#"
          class="button button--map button--map--d"
          @click.prevent="toggleMap()"
          >{{ mapcta }}</a
        >
      </div>

      <!-- map -->
      <div class="our-projects-map"></div>

      <div class="our-projects mask-right" :class="{ active: maskL0 }">
        <!-- list -->
        <div class="our-projects-wrapper">
          <!-- project block -->
          <router-link class="our-projects-block" v-bind:to="'/project/ronda'">
            <!-- icon -->
            <svg
              width="258"
              height="208"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M66.8 7.2v17.4h-47v55.7H1v14.4l18.8 8.8v32.4H1V150l18.8 3.9v21h-11v33h75c24 .1 75.7 0 89.6-2l43.2-4.1 40.4-4.5V89.7l-40.4-28V42.3l-34.4-27.7a61.2 61.2 0 00-43.4-13.5l-72 4.4v1.7z"
                fill="#000"
                stroke="#000"
                stroke-width=".1"
              />
              <path
                d="M57.9 40.6v39.8h8V40.6h-8zM69.5 40.6v39.8h11V40.6h-11zM57.9 96.9v38h8v-38h-8zM69.5 96.9v38h11v-38h-11zM57.9 151.8v22.8h8v-22.8h-8zM69.5 151.8v22.8h11v-22.8h-11zM161.3 54.7v28.8c2.7.1 9.6 2.3 15.2 4.2v-24l-15.2-9zM183.7 68l-.3 17.7 4.2 2V70.1l-3.9-2.1zM189.3 71.4v17.2l2.8 1.4V72.7l-2.8-1.3zM232.9 83.5l-.7 28 10.8 4.6V89.4l-10.1-5.9zM232.2 121.1v27l10.8 4.2v-26.9l-10.8-4.3zM189.3 115.1v17.7l2.8 1v-17.7l-2.8-1zM183.7 112.8V131l3.9 1.2v-18l-3.9-1.4zM161.3 104.2v33c3.8.2 12.2.9 15.2 2.2v-28.6l-15.2-6.6zM161.3 155.3v20.4h7.7v-19.6l-7.7-.8zM171.3 156.3v19.4h6v-18.5l-6-.9zM183.7 158.1v17.6h3v-17.6h-3zM188.3 158.1v17.6h3.8V159l-3.8-.8zM232.7 161.4v16h4.5v-14.7l-4.5-1.3z"
                fill="#fff"
              />
              <path
                d="M57.9 40.6v39.8h8V40.6h-8zM69.5 40.6v39.8h11V40.6h-11zM57.9 96.9v38h8v-38h-8zM69.5 96.9v38h11v-38h-11zM57.9 151.8v22.8h8v-22.8h-8zM69.5 151.8v22.8h11v-22.8h-11zM161.3 54.7v28.8c2.7.1 9.6 2.3 15.2 4.2v-24l-15.2-9zM183.7 68l-.3 17.7 4.2 2V70.1l-3.9-2.1zM189.3 71.4v17.2l2.8 1.4V72.7l-2.8-1.3zM232.9 83.5l-.7 28 10.8 4.6V89.4l-10.1-5.9zM232.2 121.1v27l10.8 4.2v-26.9l-10.8-4.3zM189.3 115.1v17.7l2.8 1v-17.7l-2.8-1zM183.7 112.8V131l3.9 1.2v-18l-3.9-1.4zM161.3 104.2v33c3.8.2 12.2.9 15.2 2.2v-28.6l-15.2-6.6zM161.3 155.3v20.4h7.7v-19.6l-7.7-.8zM171.3 156.3v19.4h6v-18.5l-6-.9zM183.7 158.1v17.6h3v-17.6h-3zM188.3 158.1v17.6h3.8V159l-3.8-.8zM232.7 161.4v16h4.5v-14.7l-4.5-1.3z"
                stroke="#000"
                stroke-width=".1"
              />
            </svg>
            <!-- title -->
            <div class="our-projects-block-title">
              <span>{{ strings.status_ronda }}</span>
            </div>
            <h4>Rondă</h4>
          </router-link>

          <!-- project block -->
          <router-link
            class="our-projects-block"
            v-bind:to="'/project/precupetii-vechi'"
          >
            <!-- icon -->
            <svg
              width="227"
              height="269"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M.4 226.4v-87.8l3.9-2.5v-5.4L21.7 117l2.1-3.1v-6.1l27.9-21.4V55.8l13-12V28.4L89 3.9 156.4 0l26.8 16.6v41.2l11.4 6.2v15.6l8.8 4.6-6.3 3.4 19.7 8.8v7.7l6.1 3v113.4h4.1v7l-10.2 1.8v34.5h-4v1.6h-11l-21.7 2-89.9 1.2L11 262v-3.4H7.2v-14.3H11v-12.7H2.3v-3l-1.9-2.2z"
                fill="#000"
              />
              <path
                d="M197 106.8v29l10.8 3.1v-28.3l-10.7-3.8zM197 146.4v29.4l10.8 2v-28.6l-10.7-2.8zM197 186.3v29.5l10.8.6V188l-10.7-1.7zM102.3 179.5v31.2h36.6v-31.2h-36.6zM102.3 134.3v29.4h36.6v-30.3l-36.6 1zM102.3 89.4v27.9l36.6-.8V88l-36.6 1.5zM101.9 36v34.1l37.2-1.3V34L101.9 36z"
                fill="#fff"
              />
              <path
                d="M197 106.8v29l10.8 3.1v-28.3l-10.7-3.8zM197 146.4v29.4l10.8 2v-28.6l-10.7-2.8zM197 186.3v29.5l10.8.6V188l-10.7-1.7zM102.3 179.5v31.2h36.6v-31.2h-36.6zM102.3 134.3v29.4h36.6v-30.3l-36.6 1zM102.3 89.4v27.9l36.6-.8V88l-36.6 1.5zM101.9 36v34.1l37.2-1.3V34L101.9 36z"
                stroke="#000"
                stroke-width=".1"
              />
              <path
                d="M5 174.8l10-4.7v21l-10 3.2v-19.5zM29.7 186.2v-22.7l-6.7 3v21.7l6.7-2zM34.9 161l10-4.5-.6 24.6-9.4 3.3V161zM56 151.6l8.7-4.1v26.9l-8.8 3.1v-26zM56 183.7l8.8-3v34.4l-8.9 1.3v-32.7zM34.6 190.2l10.3-3.4V218l-10.3 1.7v-29.4zM23 193.5l6.7-2v28.8l-6.7 1v-27.8zM4.2 199.3l10.8-3.6-.6 26.3-10.2 1.8v-24.5zM5 146.2v10.2l10-5.5v-11.6l-10 6.9zM23 134.6l6.2-4v12.3l-6.2 3.3v-11.6zM34.9 127l9.8-6.5v14l-9.8 5.4V127zM56 113.4l8.7-5.6v15l-8.6 5.1v-14.5z"
                fill="#fff"
              />
              <path
                d="M5 174.8l10-4.7v21l-10 3.2v-19.5zM29.7 186.2v-22.7l-6.7 3v21.7l6.7-2zM34.9 161l10-4.5-.6 24.6-9.4 3.3V161zM56 151.6l8.7-4.1v26.9l-8.8 3.1v-26zM56 183.7l8.8-3v34.4l-8.9 1.3v-32.7zM34.6 190.2l10.3-3.4V218l-10.3 1.7v-29.4zM23 193.5l6.7-2v28.8l-6.7 1v-27.8zM4.2 199.3l10.8-3.6-.6 26.3-10.2 1.8v-24.5zM5 146.2v10.2l10-5.5v-11.6l-10 6.9zM23 134.6l6.2-4v12.3l-6.2 3.3v-11.6zM34.9 127l9.8-6.5v14l-9.8 5.4V127zM56 113.4l8.7-5.6v15l-8.6 5.1v-14.5z"
                stroke="#000"
                stroke-width=".1"
              />
            </svg>
            <!-- title -->
            <div class="our-projects-block-title">
              <span>{{ strings.status_precupetii }}</span>
            </div>
            <h4>Precupeții Vechi</h4>
          </router-link>

          <!-- project block -->
          <router-link
            class="our-projects-block"
            v-bind:to="'/project/fainari'"
          >
            <!-- icon -->
            <svg
              width="222"
              height="233"
              viewBox="0 0 222 233"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1 188.954V79.3697H31.513V17.6875L76.7903 14.0785V0.95459H105.663L118.131 11.7818V34.0924L178.172 30.4833L185.718 45.2477H192.28L196.546 50.4972V59.0277L198.514 60.6682V57.0591L206.389 69.8549V99.0555L221.153 117.101V195.516L178.172 231.935H176.532V187.314C176.532 180.065 170.656 174.19 163.408 174.19C156.16 174.19 150.284 180.065 150.284 187.314V231.436L147.659 231.381V187.314C147.659 180.065 141.783 174.19 134.535 174.19C127.287 174.19 121.411 180.065 121.411 187.314V230.834L118.787 230.78V187.314C118.787 180.065 112.911 174.19 105.663 174.19C98.4148 174.19 92.539 180.065 92.539 187.314V230.233L89.9142 230.178V187.314C89.9142 180.065 84.0384 174.19 76.7903 174.19C69.5422 174.19 63.6664 180.065 63.6664 187.314V229.631L1 228.326V218.118V188.954Z"
                fill="black"
              />
              <path
                d="M1 79.3697V78.8459H0.476208V79.3697H1ZM31.513 79.3697V79.8935H32.0368V79.3697H31.513ZM31.513 17.6875L31.4714 17.1654L30.9892 17.2038V17.6875H31.513ZM76.7903 14.0785L76.832 14.6006L77.3141 14.5622V14.0785H76.7903ZM76.7903 0.95459V0.430798H76.2665V0.95459H76.7903ZM105.663 0.95459L106.006 0.55911L105.859 0.430798H105.663V0.95459ZM118.131 11.7818H118.654V11.5429L118.474 11.3863L118.131 11.7818ZM118.131 34.0924H117.607V34.6486L118.162 34.6152L118.131 34.0924ZM178.172 30.4833L178.639 30.2449L178.483 29.9399L178.141 29.9605L178.172 30.4833ZM185.718 45.2477L185.252 45.486L185.398 45.7714H185.718V45.2477ZM192.28 45.2477L192.687 44.9174L192.53 44.7239H192.28V45.2477ZM196.546 50.4972H197.069V50.3112L196.952 50.1669L196.546 50.4972ZM196.546 59.0277H196.022V59.273L196.21 59.4301L196.546 59.0277ZM198.514 60.6682L198.179 61.0706L199.038 61.7865V60.6682H198.514ZM198.514 57.0591L198.96 56.7846L197.99 55.2086V57.0591H198.514ZM206.389 69.8549H206.912V69.7067L206.835 69.5804L206.389 69.8549ZM206.389 99.0555H205.865V99.2425L205.983 99.3872L206.389 99.0555ZM221.153 117.101H221.677V116.914L221.558 116.769L221.153 117.101ZM221.153 195.516L221.492 195.916L221.677 195.759V195.516H221.153ZM178.172 231.935V232.458H178.364L178.511 232.334L178.172 231.935ZM176.532 231.935H176.008V232.458H176.532V231.935ZM150.284 231.436L150.273 231.959L150.808 231.971V231.436H150.284ZM147.659 231.381H147.135V231.894L147.648 231.905L147.659 231.381ZM121.411 230.834L121.401 231.358L121.935 231.369V230.834H121.411ZM118.787 230.78H118.263V231.293L118.776 231.303L118.787 230.78ZM92.539 230.233L92.5281 230.756L93.0628 230.768V230.233H92.539ZM89.9142 230.178H89.3904V230.691L89.9033 230.702L89.9142 230.178ZM63.6664 229.631L63.6555 230.155L64.1902 230.166V229.631H63.6664ZM1 228.326H0.476208V228.839L0.98909 228.849L1 228.326ZM0.476208 79.3697V188.954H1.52379V79.3697H0.476208ZM31.513 78.8459H1V79.8935H31.513V78.8459ZM30.9892 17.6875V79.3697H32.0368V17.6875H30.9892ZM76.7487 13.5563L31.4714 17.1654L31.5546 18.2097L76.832 14.6006L76.7487 13.5563ZM76.2665 0.95459V14.0785H77.3141V0.95459H76.2665ZM105.663 0.430798H76.7903V1.47838H105.663V0.430798ZM118.474 11.3863L106.006 0.55911L105.319 1.35007L117.787 12.1773L118.474 11.3863ZM118.654 34.0924V11.7818H117.607V34.0924H118.654ZM178.141 29.9605L118.099 33.5695L118.162 34.6152L178.204 31.0061L178.141 29.9605ZM186.185 45.0093L178.639 30.2449L177.706 30.7217L185.252 45.486L186.185 45.0093ZM192.28 44.7239H185.718V45.7714H192.28V44.7239ZM196.952 50.1669L192.687 44.9174L191.874 45.578L196.139 50.8275L196.952 50.1669ZM197.069 59.0277V50.4972H196.022V59.0277H197.069ZM198.85 60.2658L196.881 58.6253L196.21 59.4301L198.179 61.0706L198.85 60.2658ZM197.99 57.0591V60.6682H199.038V57.0591H197.99ZM206.835 69.5804L198.96 56.7846L198.068 57.3337L205.942 70.1294L206.835 69.5804ZM206.912 99.0555V69.8549H205.865V99.0555H206.912ZM221.558 116.769L206.794 98.7238L205.983 99.3872L220.747 117.433L221.558 116.769ZM221.677 195.516V117.101H220.629V195.516H221.677ZM178.511 232.334L221.492 195.916L220.814 195.116L177.834 231.535L178.511 232.334ZM176.532 232.458H178.172V231.411H176.532V232.458ZM176.008 187.314V231.935H177.055V187.314H176.008ZM163.408 174.714C170.367 174.714 176.008 180.355 176.008 187.314H177.055C177.055 179.776 170.945 173.666 163.408 173.666V174.714ZM150.808 187.314C150.808 180.355 156.449 174.714 163.408 174.714V173.666C155.87 173.666 149.76 179.776 149.76 187.314H150.808ZM150.808 231.436V187.314H149.76V231.436H150.808ZM147.648 231.905L150.273 231.959L150.295 230.912L147.67 230.857L147.648 231.905ZM147.135 187.314V231.381H148.183V187.314H147.135ZM134.535 174.714C141.494 174.714 147.135 180.355 147.135 187.314H148.183C148.183 179.776 142.073 173.666 134.535 173.666V174.714ZM121.935 187.314C121.935 180.355 127.576 174.714 134.535 174.714V173.666C126.998 173.666 120.888 179.776 120.888 187.314H121.935ZM121.935 230.834V187.314H120.888V230.834H121.935ZM118.776 231.303L121.401 231.358L121.422 230.311L118.798 230.256L118.776 231.303ZM118.263 187.314V230.78H119.311V187.314H118.263ZM105.663 174.714C112.622 174.714 118.263 180.355 118.263 187.314H119.311C119.311 179.776 113.2 173.666 105.663 173.666V174.714ZM93.0628 187.314C93.0628 180.355 98.704 174.714 105.663 174.714V173.666C98.1255 173.666 92.0152 179.776 92.0152 187.314H93.0628ZM93.0628 230.233V187.314H92.0152V230.233H93.0628ZM89.9033 230.702L92.5281 230.756L92.5499 229.709L89.9251 229.654L89.9033 230.702ZM89.3904 187.314V230.178H90.438V187.314H89.3904ZM76.7903 174.714C83.7491 174.714 89.3904 180.355 89.3904 187.314H90.438C90.438 179.776 84.3277 173.666 76.7903 173.666V174.714ZM64.1902 187.314C64.1902 180.355 69.8315 174.714 76.7903 174.714V173.666C69.2529 173.666 63.1426 179.776 63.1426 187.314H64.1902ZM64.1902 229.631V187.314H63.1426V229.631H64.1902ZM0.98909 228.849L63.6555 230.155L63.6773 229.108L1.01091 227.802L0.98909 228.849ZM0.476208 218.118V228.326H1.52379V218.118H0.476208ZM0.476208 188.954V218.118H1.52379V188.954H0.476208ZM1 228.849H24.207V227.802H1V228.849Z"
                fill="black"
              />
              <path
                d="M7.56201 85.2756V125.631H19.0454V85.2756H7.56201Z"
                fill="white"
              />
              <path
                d="M101.726 128.584H125.021V169.925H101.726V128.584Z"
                fill="white"
              />
              <path
                d="M144.706 77.4012V120.71H163.736V77.4012H144.706Z"
                fill="white"
              />
              <path
                d="M125.021 41.9668V59.3559H168.329V41.9668H125.021Z"
                fill="white"
              />
              <path
                d="M200.483 72.4795L199.826 88.8843L204.42 94.462L205.076 78.7133L200.483 72.4795Z"
                fill="white"
              />
              <path
                d="M190.312 83.6348V125.303L193.264 126.944V87.9L190.312 83.6348Z"
                fill="white"
              />
              <path
                d="M198.514 94.462L201.467 98.071V130.881L198.514 129.24V94.462Z"
                fill="white"
              />
              <path
                d="M205.076 101.68L207.701 105.617V133.834L204.42 131.865L205.076 101.68Z"
                fill="white"
              />
              <path
                d="M204.42 136.786L207.701 138.099V167.299H204.42V136.786Z"
                fill="white"
              />
              <path
                d="M198.514 133.834L201.467 135.474V167.299H198.514V133.834Z"
                fill="white"
              />
              <path
                d="M190.312 129.24L193.264 130.881V167.299H190.312V129.24Z"
                fill="white"
              />
            </svg>

            <!-- title -->
            <div class="our-projects-block-title">
              <span>{{ strings.status_fainari }}</span>
            </div>
            <h4>Făinari</h4>
          </router-link>
        </div>
        <a
          href="#"
          class="button"
          @click.prevent="AppointmentForm(true)"
          @keydown.esc="AppointmentForm(false)"
          >{{ strings.programeaza_intalnire_cta }}</a
        >
      </div>
    </div>

    <!-- Our EPOS Projects -->
    <div class="section-wrapper section-wrapper--projects section-wrapper--epos">
      <div
        class="our-projects-shadow mask-left"
        :class="{ active: maskLE0 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskLE0'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <h2>{{ strings.home_proiectele_epos }}</h2>
      </div>

      <div class="our-projects mask-right" :class="{ active: maskLE0 }">
        <!-- list -->
        <div class="our-projects-wrapper">
          <!-- project block -->
          <router-link class="our-projects-block" v-bind:to="'/project-epos/eftimie-murgu'">
            <!-- icon -->
            <svg width="259" height="228" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M.324 86.096 38.512 7.399 80.212 0l53.614 25.898 22.261-10.786L258.674 67.16v119.957L81.654 228 .324 204.611V86.096Z" fill="#000"/>
              <path d="M36.443 107.73V68.6l9.343-5.078v41.01l-9.343 3.198ZM34.123 159.023v-29.158l15.3-3.135v31.227l-15.3 1.066ZM67.483 157.957v-33.234l6.459-1.317v34.551h-6.46ZM99.526 77.819V56.185l4.389 1.756v21.257l-4.39-1.38ZM107.678 135.571v42.264l-12.479 1.568v-49.162c.435-3.789 2.737-4.44 3.856-4.757l.032-.009c.752-.146 2.973-.377 4.891 1.192 2.069 1.693 3.7 6.333 3.7 8.904ZM131.381 156.891v-32.168l14.297-2.696v34.864h-14.297ZM169.318 156.891v-34.864l10.597 1.379v33.485h-10.597ZM222.618 157.957v-29.911l14.109 2.195v26.65l-14.109 1.066ZM221.678 89.733V74.119l2.696.878.564 15.488-3.26-.752ZM234.219 93.119V79.512l2.32 1.38v13.042l-2.32-.815ZM187.44 78.258v-18.06l5.644 2.446v17.495l-5.644-1.881ZM167.562 72.3V52.36l7.65 3.01-.439 19-7.211-2.07Z" fill="#fff"/>
              <ellipse cx="41.585" cy="20.529" rx="2.508" ry="6.107" fill="#fff"/>
            </svg>
            <!-- title -->
            <div class="our-projects-block-title">
              <span>{{ strings.in_lucru }}</span>
            </div>
            <h4>Eftimie Murgu</h4>
          </router-link>
        </div>
      </div>
    </div>

    <!-- About Us -->
    <div class="section-wrapper">
      <div
        class="about-us-shadow mask-left"
        :class="{ active: maskL1 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskL1'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <h2>{{ strings.home_despre_noi_titlu }}</h2>
      </div>

      <div
        class="about-us mask-right"
        :class="{ active: maskL1 }"
        :style="homepageImgs.homepage_3 ? {backgroundImage: 'url(' + homepageImgs.homepage_3 + ')'} : {}"

      ></div>
    </div>
    <!-- About Us content -->
    <div class="subsection-wrapper">
      <div class="shape shape--withtitle"></div>
      <div
        class="about-us-content content"
        :class="{ active: isS1Active }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'isS1Active'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <h3>{{ strings.home_despre_noi_headline }}</h3>
        <p>
          {{ strings.home_despre_noi_text }}
        </p>
      </div>
    </div>

    <!-- single img left -->
    <div class="section-wrapper">
      <div
        class="single-img mask-left single-img--three"
        :class="{ active: maskL2 }"
        :style="homepageImgs.homepage_4 ? {backgroundImage: 'url(' + homepageImgs.homepage_4 + ')'} : {}"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskL2'),
          intersection: {
            threshold: 0.3
          }
        }"
      ></div>
    </div>

    <!-- single img right -->
    <div class="section-wrapper margintop mt190">
      <div
        class="single-img mask-right single-img--four"
        :class="{ active: maskR2 }"
        :style="homepageImgs.homepage_5 ? {backgroundImage: 'url(' + homepageImgs.homepage_5 + ')'} : {}"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR2'),
          intersection: {
            threshold: 0.3
          }
        }"
      ></div>
    </div>
    <!--  content -->
    <div class="subsection-wrapper margintop">
      <div class="shape shape--notitle"></div>
      <div
        class="about-us-content content"
        :class="{ active: isS2Active }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'isS2Active'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <p>
          {{ strings.home_section3_text1 }}
        </p>
        <p>{{ strings.home_section3_text2 }}</p>
      </div>
    </div>

    <!-- single img right -->
    <div class="section-wrapper mt120">
      <div
        class="single-img mask-right single-img--five"
        :class="{ active: maskR3 }"
        :style="homepageImgs.homepage_6 ? {backgroundImage: 'url(' + homepageImgs.homepage_6 + ')'} : {}"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR3'),
          intersection: {
            threshold: 0.3
          }
        }"
      ></div>
    </div>
    <!--  content -->
    <div class="subsection-wrapper">
      <div class="shape short"></div>
      <div
        class="about-us-content content mt180"
        :class="{ active: isS3Active }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'isS3Active'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <p>{{ strings.home_section4_text }}</p>
      </div>
    </div>

    <!-- Footer -->
    <div class="section-wrapper section-wrapper--footer">
      <div
        class="footer-shadow mask-left"
        :class="{ active: maskLF }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskLF'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <h2>{{ strings.contact_titlu }}</h2>
      </div>

      <div
        class="footer mask-right"
        :class="{ active: maskLF }"
        :style="homepageImgs.homepage_7 ? {backgroundImage: 'url(' + homepageImgs.homepage_7 + ')'} : {}"
      >
        <div class="footer-wrapper">
          <!-- <div class="footer-wrapper-logo">
            <a href="#" class="logo-cta">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080">
                <g data-name="Layer 1">
                  <path
                    d="M946 54.2A62.8 62.8 0 00839 98.6v734a64.7 64.7 0 01125.6 0v-734a62.9 62.9 0 00-18.4-44.4zm-44.3 87.5a41.2 41.2 0 1141.2-41.2 41.2 41.2 0 01-41.2 41.3z"
                    fill="#f9df41"
                  />
                  <circle cx="900.5" cy="848.3" r="41.2" />
                  <path
                    d="M997.3 389.9h74.4a2 2 0 012 1.9c2 21.4 37.8 37.3 86.8 37.3 49.8 0 84.1-12.6 84.1-30.1 0-19-42.7-26-106.5-33.6-72.2-8.5-137.3-38.6-137.3-107.2 0-74.3 72.8-113.6 157.6-113.6 90.2 0 157.7 53.6 159 122a2 2 0 01-2 2h-75.1a2.1 2.1 0 01-2.1-1.9c-2.2-18.6-36.4-32.4-80.5-32.4-46.2 0-77.8 11.2-77.8 27.4 0 16.8 39.3 25.9 105.8 33.6 68 7.7 137.4 34.3 137.4 105 0 76.5-73.6 118.5-164 118.5-94.4 0-162.6-56.3-164-126.8a2 2 0 012.2-2.1zM1729.8 361.9h-295.7a2.1 2.1 0 00-1.9 2.9c15.7 36.8 56.3 60.1 111.6 60.1 41.6 0 78.3-11.6 94.7-26.8a2 2 0 011.5-.5h84.4a2 2 0 012 2.8c-27.4 70.6-98.2 118.4-184.6 118.4-110.7 0-193.4-80.6-193.4-187S1431 144.5 1541 144.5s192.7 80 192.7 189.2a186.5 186.5 0 01-1.8 26.3 2 2 0 01-2 1.8zm-295-61h213.9a2.1 2.1 0 001.9-3c-15.1-36.8-57.7-59.4-109.6-59.4-51.2 0-92.4 23.3-108 59.4a2.1 2.1 0 001.9 3zM405.6 553.6v353.2a2 2 0 01-2 2.1h-75.8a2 2 0 01-2.1-2v-61.7a2 2 0 00-3.8-1c-27 45-71 73.1-126.5 73.1-98.1 0-172.4-80.6-172.4-187S97.3 543 195.4 543c55.4 0 99.4 28 126.5 73.2a2 2 0 003.8-1v-61.7a2 2 0 012-2h75.8a2 2 0 012 2zm-79.9 176.6c0-48.3-47-84.8-110-84.8S106.4 682 106.4 730.2 152.6 815 215.7 815s110-36.4 110-84.8zM812.3 732c0 106.7-73.6 187.3-172.6 187.3-55.5 0-100.1-28.6-126.7-73.8a2 2 0 00-3.8 1v195.6a2 2 0 01-2 2.1h-76a2 2 0 01-2-2v-487a2 2 0 012-2.2h76a2 2 0 012 2.1v62.3a2 2 0 003.8 1c26.6-45.2 71.2-73.8 126.7-73.8 99 0 172.6 80.7 172.6 187.4zm-82.8 0c0-48.4-47-85-110.1-85s-110.2 36.6-110.2 85 47 85 110.2 85 110.1-36.6 110.1-85zM1372.1 553.6v353.2a2 2 0 01-2 2.1h-75.8a2 2 0 01-2-2v-61.7a2 2 0 00-3.9-1c-27 45-71 73.1-126.5 73.1-98 0-172.4-80.6-172.4-187S1063.8 543 1162 543c55.5 0 99.5 28 126.5 73.2a2 2 0 003.8-1v-61.7a2 2 0 012.1-2h75.8a2 2 0 012 2zm-79.9 176.6c0-48.3-47-84.8-110-84.8S1073 682 1073 730.2s46.3 84.8 109.3 84.8 110-36.4 110-84.8zM1617.9 548.1V672a2 2 0 01-2.1 2c-84.8.6-130.3 31.9-130.3 88.3v144.3a2 2 0 01-2.1 2.1h-77a2 2 0 01-2.1-2v-353a2 2 0 012-2h77a2 2 0 012.2 2v79.5a2 2 0 004 1c28.3-54.4 72.2-87.3 126.2-88.2a2.1 2.1 0 012.2 2.1zM803 146v124a2 2 0 01-2 2c-84.9.6-130.4 31.9-130.4 88.3v144.3a2 2 0 01-2 2.1h-77a2 2 0 01-2.2-2v-353a2 2 0 012.1-2h77a2 2 0 012.1 2v79.5a2 2 0 004 1c28.3-54.4 72.2-87.3 126.3-88.2a2.1 2.1 0 012.1 2zM1793.8 646.5a2 2 0 00-2.1 2.1v121c0 24.2 15 35.6 46.2 35.6h49.9a2 2 0 012 2.1v98.3a2 2 0 01-2 2.1h-59.1c-78.3 0-118.9-37.7-118.9-113.1v-146a2 2 0 00-2-2.1h-66.4a2 2 0 01-2-2.1v-97.5a2 2 0 012-2.1h66.3a2 2 0 002.1-2.1v-76.4a2 2 0 011.5-2l77.7-21.6a2 2 0 012.6 2v98a2 2 0 002.1 2H1895a2 2 0 012 2.2v97.6a2 2 0 01-2 2z"
                  />
                </g>
              </svg>
            </a>
          </div> -->
          <div
            class="footer-wrapper-text content"
            :class="{ active: isFooterActive }"
            v-observe-visibility="{
              callback: visibilityChanged,
              intersection: {
                threshold: 0.3
              }
            }"
          >
            <h4>{{ strings.footer_titlu }}</h4>
            <p>{{ strings.footer_text }}</p>
          </div>
          <div
            class="footer-wrapper-form content"
            :class="{ active: isFooterActive }"
            v-observe-visibility="{
              callback: (isVisible, entry) =>
                visibilityChanged(isVisible, entry, 'isFooterActive'),
              intersection: {
                threshold: 0.3
              }
            }"
          >
            <h5>{{ strings.footer_form_title }}</h5>

            <!-- mobile -->
            <div class="call-us">
              <h5>{{ strings.prin_telefon }}</h5>
              <a :href="'tel:' + contact_tel" class="button">{{
                contact_tel
              }}</a>
              <h5>{{ strings.prin_email }}</h5>
            </div>

            <form
              class="ask-us form-styles"
              @submit="submitForm"
              action="#"
              method="post"
            >
              <input
                type="hidden"
                id="form_type"
                name="form_type"
                value="contact"
              />
              <input
                type="text"
                v-model="user_name"
                name="user_name"
                value=""
                :placeholder="strings.programeaza_intalnire_nume"
              />
              <input
                type="email"
                v-model="user_email"
                name="email"
                value=""
                :placeholder="strings.programeaza_intalnire_email"
              />
              <input
                type="tel"
                v-model="user_phone"
                pattern="[0-9]{4}[0-9]{3}[0-9]{3}"
                name="tel"
                value=""
                :placeholder="strings.programeaza_intalnire_tel"
              />
              <!-- <div class="select-wrapper">
                <select class="subject" name="subject">
                  <option value="precupetii">Precupetii vechi</option>
                  <option value="general">General</option>
                </select>
              </div> -->
              <textarea
                name="mesaj"
                v-model="user_message"
                rows="8"
                cols="80"
                :placeholder="strings.programeaza_intalnire_mesaj"
              ></textarea>
              <!-- newsletter -->
              <div class="gdpr_wrapper">
                <input
                  type="checkbox"
                  id="label_subscribe_newsletter_footer"
                  name="label_subscribe_newsletter_footer"
                  value="true"
                />
                <span class="checkmark"></span>
                <label
                  class="label_subscribe_newsletter"
                  for="label_subscribe_newsletter_footer"
                  >{{ strings.subscribe_newsletter }}</label
                >
              </div>

              <!-- t&c -->
              <div class="gdpr_wrapper">
                <input
                  type="checkbox"
                  id="accept_tc_2"
                  name="accept_tc_2"
                  value="Accept T&C"
                  required
                />
                <span class="checkmark"></span>
                <label
                  class="label_accept_tc_1 label_accept_tc_2"
                  for="accept_tc_2"
                  >{{ strings.programeaza_intalnire_accept_termeni }}</label
                >
              </div>

              <input
                type="submit"
                :value="strings.programeaza_intalnire_accept_trimite"
              />
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- footer social -->
    <div class="social-footer">
      <div class="social-footer-wrapper">
        <div class="social-footer-network">
          <a :href="fbUrl" target="_blank" class="icon fb">
            <svg
              width="64"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 .2 31.5)"
                fill="#F9DF41"
              />
              <path
                d="M28 32.5h6.5V16.3H39l.4-5.5h-4.9v-3c0-1.4.3-2 1.6-2h3.5V.4H35c-4.8 0-7 2-7 6.1v4.4h-3.4v5.5h3.4v16.2H28z"
                fill="#222221"
              />
            </svg>
          </a>
          <a :href="igUrl" target="_blank" class="icon ig"
            ><svg
              width="63"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 0 27.5)"
                fill="#F9DF41"
              />
              <path
                d="M31.2 5.7c4 0 4.3 0 5.9.2a5 5 0 012.6.5c.7.3 1.1.6 1.7 1.2.6.5.8 1 1.1 1.6.2.6.4 1.3.6 2.7l.1 5.9-.1 5.9a5 5 0 01-.6 2.6c-.3.7-.5 1.2-1 1.7-.7.6-1 .9-1.8 1.1-.5.2-1.2.5-2.6.6l-6 .1-5.8-.1a5 5 0 01-2.7-.6c-.7-.2-1-.5-1.6-1-.6-.6-.9-1-1.2-1.8-.1-.5-.4-1.2-.5-2.6-.2-1.6-.2-2-.2-6 0-3.8 0-4.3.2-5.8a5 5 0 01.5-2.7c.3-.7.6-1 1.2-1.6.5-.6 1-.9 1.6-1.2.6-.1 1.3-.4 2.7-.5 1.4-.2 2-.2 5.9-.2zm0-2.6l-6 .1c-1.6.2-2.7.3-3.5.7-1 .4-1.9.9-2.6 1.7-.8.8-1.2 1.7-1.6 2.5-.5 1-.6 2-.7 3.5-.2 1.6-.2 2.1-.2 6 0 4 0 4.5.2 6 0 1.6.2 2.7.7 3.6.4 1 .8 1.8 1.6 2.5.9.8 1.7 1.3 2.6 1.7 1 .4 2 .5 3.5.7l6 .1 6-.1c1.5-.2 2.7-.3 3.5-.7 1-.4 1.8-.9 2.5-1.7.9-.8 1.3-1.7 1.7-2.5.4-1 .6-2 .7-3.5.2-1.6.2-2.1.2-6 0-4 0-4.5-.2-6C45.5 10 45.3 9 45 8c-.4-1-.8-1.8-1.7-2.5a8.8 8.8 0 00-2.5-1.7c-1-.4-2-.5-3.5-.7l-6-.1z"
                fill="#222221"
              />
              <path
                d="M31.2 10.2a7.5 7.5 0 00-7.6 7.6c0 4.2 3.4 7.6 7.6 7.6 4.2 0 7.5-3.4 7.5-7.6a7.7 7.7 0 00-7.5-7.6zm0 12.5a5 5 0 01-5-5 5 5 0 015-4.8 5 5 0 014.9 4.9c-.2 2.7-2.3 4.9-5 4.9zM40.7 10c0 1-.8 1.8-1.8 1.8S37 10.9 37 9.9c0-1 .8-1.8 1.8-1.8 1 .2 1.8.9 1.8 1.8z"
                fill="#222221"
              /></svg
          ></a>
          <a
            v-if="liUrl.length > 1"
            :href="liUrl"
            target="_blank"
            class="icon in"
          >
            <svg
              width="63"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 .2 30.7)"
                fill="#F9DF41"
              />
              <path fill="#000" d="M14.9 10.2h7.4v22.7h-7.4z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33.9 19.7c.5-1.6 2-3.7 4.4-3.7 2.3 0 3.5 2.3 3.5 3.4h7.4c0-1.9-.5-6-4-8.3-1.4-1-5.3-2.3-8.8 0-.8.6-1.8 1.7-2.5 3v-4h-7.4V33h7.4V19.7zm7.9-.3h7.4V33h-7.4V19.4z"
                fill="#000"
              />
              <ellipse cx="18.9" cy="3.7" rx="3.9" ry="3.7" fill="#000" />
            </svg>
          </a>
        </div>
        <span
          ><router-link v-bind:to="'/privacypolicy'">{{
            strings.privacy_title
          }}</router-link></span
        >
        <span>{{ strings.all_rights_reserved }}</span>
      </div>
      <!-- scroll to top -->
      <div class="scroll-to-top">
        <a href="#" @click.prevent="scrollTo('.home-hero')">
          <svg
            width="24"
            height="34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1c-.5-.6-1.5-.6-2 0l-9.6 9.5a1.5 1.5 0 102.1 2.1L12 4.1l8.5 8.5a1.5 1.5 0 102.1-2.1L13.1.9zm.5 33V2h-3v32h3z"
              fill="#000"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import smoothscroll from "smoothscroll-polyfill";
import gmapsInit from "../utils/gmaps";
import router from "../router";
import { bus } from "../main";
import dateFormat from "dateformat";

// kick off the polyfill!
smoothscroll.polyfill();
// import Rellax from "rellax";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      loading: false,
      locale: "ro",
      form_type: "",
      user_name: "",
      user_email: "",
      user_phone: "",
      user_date: "",
      user_message: "",
      isMobile: false,
      isHeroActive: false,
      isS1Active: false,
      isS2Active: false,
      isS3Active: false,
      isFooterActive: false,
      maskR0: false,
      maskL0: false,
      maskLE0: false,
      maskR1: false,
      maskL1: false,
      maskR2: false,
      maskL2: false,
      maskR3: false,
      maskL3: false,
      maskRF: false,
      maskLF: false,
      posx: 100,
      lastScroll: 0,
      content: {},
      strings: {
        home_headline: "",
        home_subheadline: "",
        home_proiectele_noastre: "",
        home_proiectele_epos: "",
        programeaza_intalnire_cta: "",
        programeaza_intalnire_headline: "",
        programeaza_intalnire_thanks: "",
        home_despre_noi_titlu: "",
        home_despre_noi_headline: "",
        home_despre_noi_text: "",
        home_section3_text1: "",
        home_section3_text2: "",
        home_section4_text: "",
        contact_titlu: "",
        footer_titlu: "",
        footer_text: "",
        footer_form_title: "",
        programeaza_intalnire_accept_trimite: "",
        all_rights_reserved: "",
        vezi_harta: "",
        vezi_lista: "",
        ask_us_thankyou: "",
        prin_telefon: "",
        prin_email: ""
      },
      homepageImgs: {
        homepage_1: "",
        homepage_2: "",
        homepage_3: "",
        homepage_4: "",
        homepage_5: "",
        homepage_6: "",
        homepage_7: ""
      },
      mapcta: "",
      mapctastate: false,
      fbUrl: "",
      igUrl: "",
      liUrl: "",
      contact_tel: ""
    };
  },
  methods: {
    fetchHomeImgs: function() {
      var self = this;
      // get homepage images
      axios
        .get("https://api.riseapart.com")
        .then(function(res) {
          var images = res.data.mediaFiles;

          self.homepageImgs.homepage_1 = images.homepage_1;
          self.homepageImgs.homepage_2 = images.homepage_2;
          self.homepageImgs.homepage_3 = images.homepage_3;
          self.homepageImgs.homepage_4 = images.homepage_4;
          self.homepageImgs.homepage_5 = images.homepage_5;
          self.homepageImgs.homepage_6 = images.homepage_6;
          self.homepageImgs.homepage_7 = images.homepage_7;
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    },
    fetchData: function() {
      var self = this;

      // get translatable strings
      axios
        .get("https://api.riseapart.com/content?_limit=100", {
          headers: {
            "X-Locale": self.locale
          }
        })
        .then(function(data) {
          let stringsObj = data.data.data;
          let x;

          for (x = 0; x < stringsObj.length; x++) {
            let newObj = stringsObj[x];
            let newKey = Object.keys(newObj);
            self.strings[newObj[newKey].key] = newObj[newKey].value;
          }

          //
          self.mapcta = self.strings.vezi_harta;

          // console.log("strings: ", self.strings);
        })
        .catch(function(error) {
          console.log("Error", error);
        });

      // get settings (social urls)
      axios
        .get("https://api.riseapart.com/configuration")
        .then(function(res) {
          var facebookUrl = res.data.data.filter(obj => {
            return obj.key === "FACEBOOK_URL";
          });

          var instagramUrl = res.data.data.filter(obj => {
            return obj.key === "INSTAGRAM_URL";
          });

          var linkedinUrl = res.data.data.filter(obj => {
            return obj.key === "LINKEDIN_URL";
          });

          var contactTel = res.data.data.filter(obj => {
            return obj.key === "CONTACT_TEL";
          });

          self.fbUrl = facebookUrl[0].defaultValue;
          self.igUrl = instagramUrl[0].defaultValue;
          self.liUrl = linkedinUrl[0].defaultValue;
          self.contact_tel = contactTel[0].defaultValue;
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    },
    mq() {
      this.isMobile = window.matchMedia("(max-width: 1024px)").matches;
    },
    toggleMap() {
      var el = document.querySelector(".our-projects-map");
      this.mapctastate = !this.mapctastate;

      if (this.mapctastate) {
        this.mapcta = this.strings.vezi_lista;
        el.classList.add("visible");
      } else {
        this.mapcta = this.strings.vezi_harta;
        el.classList.remove("visible");
      }
    },
    scrollTo(el) {
      document.querySelector(el).scrollIntoView({
        behavior: "smooth"
      });
    },
    visibilityChanged(isVisible, entry, param) {
      if (isVisible) {
        if (param === "isHeroActive") {
          this.isHeroActive = true;
        }

        if (param === "isS1Active") {
          this.isS1Active = true;
          // scroll
          // window.addEventListener("scroll", this.handleScroll);
        }

        if (param === "isS2Active") {
          this.isS2Active = true;
        }

        if (param === "isS3Active") {
          this.isS3Active = true;
        }

        if (param === "isFooterActive") {
          this.isFooterActive = true;
        }

        // masks
        if (param === "maskR0") {
          this.maskR0 = true;
        }

        if (param === "maskL0") {
          this.maskL0 = true;
        }

        if (param === "maskLE0") {
          this.maskLE0 = true;
        }

        if (param === "maskR1") {
          this.maskR1 = true;
        }

        if (param === "maskL1") {
          this.maskL1 = true;
        }

        if (param === "maskL2") {
          this.maskL2 = true;
        }

        if (param === "maskR2") {
          this.maskR2 = true;
        }

        if (param === "maskR3") {
          this.maskR3 = true;
        }

        if (param === "maskLF") {
          this.maskLF = true;
        }
      }

      if (!isVisible) {
        if (param === "isHeroActive") {
          this.isHeroActive = false;
        }

        if (param === "isS1Active") {
          this.isS1Active = false;
          // window.removeEventListener("scroll", this.handleScroll);
        }

        if (param === "isS2Active") {
          this.isS2Active = false;
        }

        if (param === "isS3Active") {
          this.isS3Active = false;
        }

        if (param === "isFooterActive") {
          this.isFooterActive = false;
        }

        //masks
        if (param === "maskR0") {
          this.maskR0 = false;
        }

        if (param === "maskL0") {
          this.maskL0 = false;
        }

        if (param === "maskLE0") {
          this.maskLE0 = false;
        }

        if (param === "maskR1") {
          this.maskR1 = false;
        }

        if (param === "maskL1") {
          this.maskL1 = false;
        }

        if (param === "maskL2") {
          this.maskL2 = false;
        }

        if (param === "maskR2") {
          this.maskR2 = false;
        }

        if (param === "maskR3") {
          this.maskR3 = false;
        }

        if (param === "maskLF") {
          this.maskLF = false;
        }
      }
    },
    handleScroll() {
      // Any code to be executed when the window is scrolled
      // var positionY = window.pageYOffset / 10;
      //
      let currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop; // Get Current Scroll Value

      if (currentScroll > 0 && this.lastScroll <= currentScroll) {
        this.lastScroll = currentScroll;
        // console.log("Scrolling DOWN");
        this.posx--;
      } else {
        this.lastScroll = currentScroll;
        // console.log("Scrolling UP");
        this.posx++;
      }

      if (this.posx >= 0) {
        document.querySelector(".about-us.mask-right").style.transform =
          "translate3d(" +
          this.posx * 1.8 +
          "px, " +
          this.posx * 1.8 +
          "px , 0px)";
      }
    },
    introAnimation(bool) {
      var loadingEl = document.querySelector(".loading-animation");
      if (bool) {
        loadingEl.classList.add("loaded");
        setTimeout(function() {
          loadingEl.parentNode.removeChild(loadingEl);
        }, 1000);
      } else {
        loadingEl.classList.add("loaded");
        loadingEl.parentNode.removeChild(loadingEl);
      }
    },
    AppointmentForm(bool) {
      const el = document.querySelector(".appointment-form");
      if (bool) {
        document.querySelector("#date").value = dateFormat(
          new Date(),
          "yyyy-mm-dd"
        );
        el.classList.add("visible");
      } else {
        el.classList.remove("visible");
      }
    },
    submitForm(e) {
      e.preventDefault();

      var form = e.srcElement;
      var form_type = form.querySelector("#form_type").value;

      let bodyFormData = new FormData();
      bodyFormData.set("type", form_type);
      bodyFormData.set("email", this.user_email);
      bodyFormData.set("name", this.user_name);
      bodyFormData.set("phone", this.user_phone);
      bodyFormData.set("message", this.user_message);
      bodyFormData.set("tos", true);

      // console.log(form_type);

      if (form_type === "meeting") {
        if (
          document.querySelector("#label_subscribe_newsletter") ||
          document.querySelector("#label_subscribe_newsletter").checked
        ) {
          bodyFormData.set("news", true);
        }
      }

      if (form_type === "contact") {
        if (
          document.querySelector("#label_subscribe_newsletter_footer") ||
          document.querySelector("#label_subscribe_newsletter_footer").checked
        ) {
          bodyFormData.set("news", true);
        }
      }

      if (form_type === "meeting") {
        bodyFormData.set("date", dateFormat(this.user_date, "dd-mm-yyyy"));
      }

      // set loading animation on button
      form.querySelector('input[type="submit"]').classList.add("loading");

      var self = this;

      axios({
        method: "post",
        url: "https://api.riseapart.com/send-form",
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data"
          // "X-Locale": self.locale
        }
      })
        .then(function(response) {
          // stop loading animation
          form
            .querySelector('input[type="submit"]')
            .classList.remove("loading");
          //handle success
          // console.log(response);
          if (response.data.data.sent === 1 && form_type === "meeting") {
            // console.log(form);
            // thank you message
            form.parentElement.querySelector("h5").style.display = "none";
            form.style.display = "none";
            form.parentElement.querySelector("h6").style.display = "block";
          }

          if (response.data.data.sent === 1 && form_type === "contact") {
            // console.log(form);
            // thank you message
            form.reset();
            self.user_name = "";
            self.user_email = "";
            self.user_phone = "";
            self.user_message = "";
            form.parentElement.querySelector("h5").innerHTML =
              self.strings.ask_us_thankyou;
          }
        })
        .catch(function(response) {
          // stop loading animation
          form
            .querySelector('input[type="submit"]')
            .classList.remove("loading");

          //handle error
          // console.log(response);
          if (response.name) {
            form
              .querySelector("input[name='user_name']")
              .classList.add("error");
          }

          if (response.email) {
            form
              .querySelector("input[name='user_email']")
              .classList.add("error");
          }

          if (response.phone) {
            form
              .querySelector("input[name='user_phone']")
              .classList.add("error");
          }
        });
    }
  },
  async mounted() {
    // get homepage images
    await this.fetchHomeImgs();
    // await this.fetchData(); // duplicate
    // gmaps
    try {
      const google = await gmapsInit();
      const precupeti = { lat: 44.44769, lng: 26.11796 };
      const ronda = { lat: 44.43691, lng: 26.12572 };
      const fainari = { lat: 44.44866, lng: 26.12109 };
      const center = { lat: 44.444722, lng: 26.120497 };
      const murgu = { lat: 44.42883, lng: 26.12700 };

      var map = new google.maps.Map(
        document.querySelector(".our-projects-map"),
        {
          center: center,
          zoom: 14,
          styles: [
            {
              elementType: "geometry",
              stylers: [
                {
                  color: "#f5f5f5"
                }
              ]
            },
            {
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#616161"
                }
              ]
            },
            {
              elementType: "labels.text.stroke",
              stylers: [
                {
                  color: "#f5f5f5"
                }
              ]
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#bdbdbd"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [
                {
                  color: "#eeeeee"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#757575"
                }
              ]
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [
                {
                  color: "#e5e5e5"
                }
              ]
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e"
                }
              ]
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [
                {
                  color: "#ffffff"
                }
              ]
            },
            {
              featureType: "road.arterial",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#757575"
                }
              ]
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [
                {
                  color: "#dadada"
                }
              ]
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#616161"
                }
              ]
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e"
                }
              ]
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [
                {
                  color: "#e5e5e5"
                }
              ]
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [
                {
                  color: "#eeeeee"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [
                {
                  color: "#c9c9c9"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e"
                }
              ]
            }
          ]
        }
      );
      // The markers
      // The markers
      var markers = [];

      markers[0] = new google.maps.Marker({
        position: precupeti,
        url: "precupetii-vechi",
        icon: {
          url: require("../assets/precupetii-marker_" + this.locale + ".png"),
          size: new google.maps.Size(117, 168),
          scaledSize: new google.maps.Size(117, 168)
        },
        map: map
      });
      markers[1] = new google.maps.Marker({
        position: ronda,
        url: "ronda",
        icon: {
          url: require("../assets/ronda-marker_" + this.locale + ".png"),
          size: new google.maps.Size(117, 168),
          scaledSize: new google.maps.Size(117, 168)
        },
        map: map
      });
      markers[2] = new google.maps.Marker({
        position: fainari,
        url: "fainari",
        icon: {
          url: require("../assets/fainari-marker_" + this.locale + ".png"),
          size: new google.maps.Size(117, 168),
          scaledSize: new google.maps.Size(117, 168)
        },
        map: map
      });
      markers[3] = new google.maps.Marker({
        position: murgu,
        url: "eftimie-murgu",
        icon: {
          url: require("../assets/murgu-marker_" + this.locale + ".png"),
          size: new google.maps.Size(117, 168),
          scaledSize: new google.maps.Size(117, 168)
        },
        map: map
      });

      // set marker url
      for (var i = 0; i < markers.length; i++) {
        google.maps.event.addListener(markers[i], "click", function() {
          if (this.url === 'eftimie-murgu') {
            router.push({ path: `/project-epos/${this.url}` });
          } else {
            router.push({ path: `/project/${this.url}` });
          }
        });
      }
    } catch (error) {
      console.error(error);
    }

    //
    if (localStorage.getItem("loaded") !== "true") {
      setTimeout(
        function() {
          this.introAnimation(true);
        }.bind(this),
        3000
      );
    } else {
      this.introAnimation(false);
    }

    // update the date form input
    document.getElementById("date").valueAsDate = new Date();
  },
  created() {
    // langCheck
    if (!this.$route.query.lang) {
      router.push({ query: { lang: "ro" } });
      this.locale = "ro";
    } else {
      this.locale = this.$route.query.lang;
      this.fetchData();
    }

    // lang switch
    bus.$on("lang", data => {
      this.locale = data.lang;
      router.push({ query: { lang: this.locale } });
      this.fetchData();
    });
    // window.addEventListener("scroll", this.handleScroll);
    //
    this.mq();
    window.addEventListener("resize", this.mq);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.mq);
  },
  destroyed() {
    // window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    "$route.params": {
      handler() {
        // this.fetchData(); // rm duplicate breaking nav consistency
      },
      immediate: true
    },
    "$route.query": {
      handler() {
        // this.fetchData(); // rm duplicate breaking nav consistency
      }
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/_reset.scss";
@import "~@/assets/styles/_variables.scss";
@import "~@/assets/styles/_components.scss";
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600&display=swap");

html {
  scroll-behavior: smooth;
}

.call-us {
  display: none;
}

.gdpr_wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-top: 10px;

  @media screen and (max-width: 768px) {
    min-height: 50px;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    background: transparent;
    border: 1px solid $color-yellow;
    border-radius: 5px;
    pointer-events: none;

    &:hover {
      cursor: pointer;
    }
  }

  .label_subscribe_newsletter,
  .label_accept_tc_1 {
    display: inline-block;
    width: 90%;
    text-align: left;
    font-size: 10px !important;
    line-height: 14px !important;
    text-transform: none !important;
    border: 0 !important;

    &:hover {
      cursor: pointer;
    }
  }

  input[type="checkbox"] {
    display: inline-block;
    width: 20px !important;
    height: 20px;
    margin: 0px 20px 0 0 !important;
    padding: 0 !important;
    opacity: 0;

    &:hover {
      cursor: pointer;
    }

    &:checked ~ .checkmark {
      background-color: $color-yellow;
    }
  }

  &--black {
    .checkmark {
      border: 1px solid $color-dark;
    }

    input[type="checkbox"] {
      &:checked ~ .checkmark {
        background-color: $color-dark;
      }
    }
  }
}

.loading-animation {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: $color-light;
  z-index: 300;
  opacity: 1;
  // -webkit-transition: opacity 0.3s linear;
  // transition: opacity 0.3s linear;

  &.loaded {
    opacity: 0;
  }

  &-graphic {
    display: block;
    width: 320px;
    height: 47px;
    margin: auto;
    animation-name: fadeOut;
    animation-delay: 1.2s;
    animation-duration: 0.4s;
    animation-fill-mode: forwards;

    @media screen and (max-width: 768px) {
      width: 300px;
      height: 50px;
      transform: scale(0.8);
    }

    @keyframes fadeOut {
      0% {
        opacity: 1;
      }
      20% {
        opacity: 1;
      }
      40% {
        opacity: 1;
      }
      70% {
        opacity: 0.5;
      }
      90% {
        opacity: 0;
      }
      100% {
        opacity: 0;
      }
    }

    span {
      position: absolute;
      display: block;
      width: 30px;
      height: 30px;
      background: $color-dark;
      border-radius: 30px;
      transform: translate3d(260px, 8px, 0);
      transition: all 0.3s ease;
      animation-name: animateBall;
      animation-duration: 1s;

      @keyframes animateBall {
        0% {
          transform: translate3d(-20px, 8px, 0);
        }
        20% {
          transform: translate3d(-20px, 8px, 0);
        }
        40% {
          transform: translate3d(-20px, 8px, 0);
        }
        70% {
          transform: translate3d(265px, 8px, 0);
        }
        90% {
          transform: translate3d(260px, 8px, 0);
        }
        100% {
          transform: translate3d(260px, 8px, 0);
        }
      }
    }
  }

  &-logo {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 200px;
    height: 120px;
    margin: auto;
    opacity: 0;

    animation-name: fadeIn;
    animation-delay: 1.1s;
    animation-duration: 1s;
    animation-fill-mode: forwards;

    @media screen and (max-width: 768px) {
      width: 200px;
      height: 120px;
      transform: scale(0.8);
    }

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      20% {
        opacity: 0;
      }
      40% {
        opacity: 0;
      }
      70% {
        opacity: 0;
      }
      90% {
        opacity: 0.5;
      }
      100% {
        opacity: 1;
      }
    }
  }
}

.appointment {
  &-cta {
    // display: none;
    position: fixed;
    top: 55vh;
    right: 0;
    display: block;
    max-width: 175px;
    padding: 13px 26px;
    background: $color-yellow;
    border-radius: 31px 0 0 31px;
    z-index: 91;
    transform: translate3d(10px, 0, 0);
    transition: transform 0.3s ease;

    @media screen and (max-width: 768px) {
      top: 75vh;

      a {
        position: relative;
        font-size: 0;

        &:after {
          content: url("~@/assets/appointment-icon.svg");
          display: block;
          width: 10px;
          height: 10px;
          transform: scale(0.5) translate3d(-20px, -38px, 0);
        }
      }
    }
  }

  &-form {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 300;
    transform: translate3d(100vw, 0, 0);
    opacity: 0;
    transition: opacity 0.3s ease;

    h6 {
      display: none;
      margin: -50px 0 0;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 300;
      font-size: 20px;
      line-height: 30px;
      color: $color-dark;
      text-align: left;

      @media screen and (max-width: 768px) {
        width: 70vw;
        margin: 50px auto 0;
      }
    }

    &.visible {
      opacity: 1;
      transform: translate3d(0, 0, 0);

      .appointment-form-shape {
        transform: translate3d(0, 0, 0);

        @media screen and (max-width: 768px) {
          -webkit-mask-position: -200vw -40px;
          mask-position: -200vw -40px;
        }
      }
    }

    &-shape.mask-right {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 100vw;
      height: 100vh;
      background: $color-yellow;
      -webkit-mask-position: 0 center;
      mask-position: 0 center;
      transform: translate3d(100vw, 200px, 0);
      transition: transform 0.3s ease 0.4s;

      @media screen and (max-width: 768px) {
        flex-direction: column;
        padding: 60px 0;
        -webkit-mask-size: 1920px 940px;
        mask-size: 1920px 940px;
        -webkit-mask-position: 100vw 0;
        mask-position: 100vw 0;
        transition: -webkit-mask-position 0.4s ease 0.2s;
      }
    }

    &-col:nth-child(1) {
      margin: -100px 100px 0 0;

      @media screen and (max-width: 768px) {
        margin: 0 0 50px;
        transform: scale(0.7);
      }
    }

    &-col:nth-child(2) {
      margin: -50px 0 0 0;
    }

    &-col,
    form {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      h5 {
        display: block;
        width: 70%;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 20px;
        line-height: 30px;
        color: $color-dark;
        text-align: left;
      }
    }
  }
}

.mask-right {
  -webkit-mask-image: url("~@/assets/mask-right.png");
  mask-image: url("~@/assets/mask-right.png");
  -webkit-mask-position: 20vw 4vh;
  mask-position: 20vw 4vh;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 120vw 100vh;
  mask-size: 120vw 100vh;
  object-fit: cover;
  transition: -webkit-mask-position 1s ease;

  &.active {
    -webkit-mask-position: -10vw 0;
    mask-position: -10vw 0;
  }
  //
  // footer form fix
  @media screen and (max-height: 850px) {
    -webkit-mask-size: 120vw 900px;
    mask-size: 120vw 900px;
  }

  @media screen and (max-width: 768px) {
    -webkit-mask-position: -200vw 0;
    mask-position: -200vw 0;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 1920px 940px;
    mask-size: 1920px 940px;
    object-fit: cover;
    transition: none;

    &.active {
      -webkit-mask-position: -200vw 0;
      mask-position: -200vw 0;
    }
  }
}

.mask-left {
  -webkit-mask-image: url("~@/assets/mask-left.png");
  mask-image: url("~@/assets/mask-left.png");
  -webkit-mask-position: -20vw -4vh;
  mask-position: -20vw -4vh;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 120vw 100vh;
  mask-size: 120vw 100vh;
  object-fit: cover;
  transition: -webkit-mask-position 1s ease 0.4s;

  &.active {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
  }

  @media screen and (max-width: 1200px) {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 140vw 90vh;
    mask-size: 140vw 90vh;
    object-fit: cover;
    transition: none;

    &.active {
      -webkit-mask-position: 0 0;
      mask-position: 0 0;
    }
  }

  @media screen and (max-width: 768px) {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 1920px 940px;
    mask-size: 1920px 940px;
    object-fit: cover;
    transition: none;

    &.active {
      -webkit-mask-position: 0 0;
      mask-position: 0 0;
    }
  }
}

.margintop {
  margin-top: -28vh;
}

.margintop25 {
  margin-top: -25vh;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.content {
  // @media screen and (min-width: 768px) {
  opacity: 0;
  transform: translate3d(0, 60px, 0);
  transition: all 1s ease;

  &.active {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  // }
}

.section-wrapper {
  position: relative;
  display: block;
  width: 100vw;
  height: 100vh;

  > div:not(.social-footer):not(.materials):not(.vc-collapse) {
    position: absolute;
    top: 0;
    left: 0;

    + div {
      top: 120px;

      @media screen and (max-width: 760px) {
        top: 0;
      }
    }
  }

  h2 {
    display: block;
    margin-top: 140px;
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: $color-yellow;
    text-align: center;
  }

  &--projects {
    @media screen and (min-width: 1200px) {
      min-height: 820px;
    }

    .button--map {
      position: relative;
      top: -100px;
      left: 20px;
      margin: 0 auto;
      padding: 10px 20px;
      color: $color-yellow;

      &:hover {
        color: $color-dark;
      }
    }
  }

  &--epos {
    margin-bottom: -100px;

    h2 {
      margin-top: 130px;
      color: $color-orange;
      white-space: break-spaces;
    }

    .our-projects-wrapper {
      justify-content: center !important;
    }

    .our-projects-block-title {
      background-color: $color-orange !important;
    }
  }

  @media screen and (max-height: 850px) {
    &--footer {
      min-height: 900px;
    }
  }
}

.subsection-wrapper {
  position: relative;
  z-index: 110;

  .shape {
    display: block;
    width: 42vw;
    height: 370px;
    margin: -150px auto -270px;
    background: $color-light;
    border-radius: 180px;
    transform: rotate(10deg);

    &.short {
      margin: -200px auto -150px;

      + .content p {
        margin: -250px auto 70px;
      }
    }
  }

  h3,
  p {
    position: relative;
    display: block;
    margin: 0 auto;
    font-family: "Poppins", sans-serif;
    font-style: normal;
    color: $color-dark;
    z-index: 120;
  }

  h3 {
    margin-bottom: 40px;
    max-width: 380px;
    font-weight: 600;
    font-size: 38px;
    line-height: 48px;
    text-align: center;
  }

  p {
    max-width: 32vw;
    font-weight: 300;
    font-size: 18px;
    line-height: 30px;
    text-align: justify;

    + p {
      margin-top: 20px;
    }
  }
}

// @media screen and (min-width: 1024px) {
.home {
  width: 100vw;
  // max-width: 1440px;
  margin: 0 auto;
  // overflow-x: hidden;

  &-hero {
    position: relative;
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 0;
    margin-left: 0;
    margin-bottom: -100px;
    background-color: $color-dark;
    -webkit-mask-position: -20vw -20px;
    mask-position: -20vw -20px;
    z-index: 90;
    pointer-events: none;

    video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      object-fit: cover;
      background-color: $color-dark;
      opacity: 0.9;
      z-index: 10;

      @media screen and (min-width: 1024px) {
        min-height: 900px;
      }
    }

    @media screen and (min-width: 1024px) {
      min-height: 900px;
      background-image: none !important;
    }

    @media screen and (min-width: 1920px) {
      margin-bottom: -160px;
    }

    &-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;

      &-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 20;
        transition-delay: 1s;
      }

      h2,
      h3 {
        font-family: "Poppins", sans-serif;
        z-index: 20;
      }

      h3 {
        display: block;
        width: 30vw;
        margin: 0 auto;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 22px;
        text-align: center;
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: $color-light;
        text-shadow: 0px 3.11431px 3.11431px rgba(0, 0, 0, 0.18),
          0px 2px 4px rgba(0, 0, 0, 0.25), 0px 2px 4px rgba(0, 0, 0, 0.25),
          0px 2px 4px rgba(0, 0, 0, 0.25), 0px 2px 4px rgba(0, 0, 0, 0.25);
      }

      h2 {
        display: block;
        margin: 25px auto;
        font-style: normal;
        font-weight: 600;
        font-size: 66px;
        line-height: 70px;
        color: $color-light;
        text-shadow: 0px 2px 3.11431px rgba(0, 0, 0, 0.18),
          0px 2px 4px rgba(0, 0, 0, 0.25), 0px 2px 4px rgba(0, 0, 0, 0.25),
          0px 2px 4px rgba(0, 0, 0, 0.25);
      }

      a {
        display: inline-block;
        margin: 0 auto;
        padding: 17px 32px;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        letter-spacing: 0.2em;
        color: $color-light;
        text-shadow: 0px 2px 4px $color-dark;
        text-transform: uppercase;
        text-decoration: none;
        background: rgba(255, 255, 255, 0.1);
        border: 2px solid rgba(255, 255, 255, 0.7);
        border-radius: 84px;
        transition: all 0.3s ease;
        z-index: 20;
        pointer-events: all;

        &:hover {
          cursor: pointer;
          background: $color-light;
          color: $color-dark;
          text-shadow: none;
        }
      }
    }
  }

  .our-projects {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-size: cover;
    background-position: center center;
    background-repeat: none;
    background-color: $color-light;
    text-align: center;
    transition: opacity 0.3s ease, -webkit-mask-position 1s ease;

    &-shadow {
      display: block;
      width: 100vw;
      height: 100vh;
      background-color: $color-dark;
    }

    &-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: calc(1200px - 100px);
      height: 60%;
      margin: 0 auto 0;

      @media screen and (min-width: 1200px) {
        min-height: 520px;

        .button {
          margin-left: 30px;
        }
      }
    }

    &-map {
      top: 140px !important;
      display: block;
      width: 100vw;
      height: 78vh;
      opacity: 0;
      transform: translate3d(100vw, 0, 0);
      transition: all 0.3s ease;

      &.visible {
        opacity: 1;
        transform: translate3d(0, 0, 0);
        z-index: 60;

        + .our-projects {
          opacity: 0;
        }
      }
    }

    &-block {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-decoration: none;

      &:hover {
        cursor: pointer;

        svg {
          transform: translate3d(0, -5px, 0) scale(0.9);

          @media screen and (max-width: 768px) {
            transform: translate3d(0, -5px, 0) scale(0.55);
          }
        }

        .our-projects-block-title {
          transform: translate3d(0, 5px, 0) rotate(8deg);
        }

        h4 {
          transform: translate3d(0, 5px, 0);
        }
      }

      &:nth-child(2) {
        margin-top: 100px;
      }

      &:nth-child(3) {
        margin-top: 150px;
      }

      svg {
        transform: translate3d(0, 0, 0) scale(0.9);
        transition: all 0.3s ease;
        z-index: 50;
      }

      &-title {
        display: inline-block;
        margin-top: -10px;
        padding: 20px 40px;
        border-radius: 60px;
        background-color: $color-yellow;
        transform: translate3d(0, 0, 0) rotate(8deg);
        transition: all 0.3s ease;

        span {
          display: block;
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 27px;
          text-align: center;
          letter-spacing: 0.2em;
          color: $color-dark;
          text-transform: uppercase;
          transform: rotate(-8deg);
        }
      }

      h4 {
        display: block;
        margin-top: 16px;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 32px;
        line-height: 33px;
        text-align: center;
        color: $color-dark;
        transition: all 0.3s ease;
      }
    }
  }

  .about-us {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-image: url("~@/assets/content/section-2.jpg");
    background-size: cover;
    background-position: 0 45%;
    background-repeat: no-repeat;
    // background-attachment: fixed;
    background-color: $color-light;
    text-align: center;

    &-shadow {
      display: block;
      width: 100vw;
      height: 100vh;
      background-color: $color-yellow;

      h2 {
        color: $color-dark;
      }
    }

    &-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 1440px;
      height: 60%;
      margin: 0 auto 0;
    }
  }

  .single-img {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-size: cover;
    background-position: center center;
    background-repeat: none;
    background-color: $color-light;
    text-align: center;

    &--three {
      background-image: url("~@/assets/content/section-3.jpg");

      @media screen and (max-height: 768px) {
        background-position: 34% center;
      }
    }

    &--four {
      background-image: url("~@/assets/content/section-4.jpg");
    }

    &--five {
      background-image: url("~@/assets/content/section-5.jpg");
    }
  }

  .footer {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-image: url("~@/assets/footer-bg.jpg");
    background-size: cover;
    background-position: center center;
    background-repeat: none;
    background-color: $color-light;
    text-align: center;

    // footer form fix
    @media screen and (max-height: 850px) {
      min-height: 900px;
    }

    &-shadow {
      display: block;
      width: 100vw;
      height: 100vh;
      background-color: $color-yellow;

      h2 {
        color: $color-dark;
      }
    }

    &-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      max-width: calc(1200px - 100px);
      height: 60%;
      margin: 200px auto 0;

      &-logo {
        display: block;
        width: 161px;
        height: 91px;
      }

      &-text {
        display: block;
        width: 17vw;
        min-width: 300px;
        // margin-left: 50px;

        h4,
        p {
          font-family: "Poppins", sans-serif;
          font-style: normal;
        }

        h4 {
          font-weight: 600;
          font-size: 38px;
          line-height: 57px;
          text-align: left;
          color: $color-yellow;
        }

        p {
          font-weight: 300;
          font-size: 18px;
          line-height: 30px;
          text-align: left;
          color: $color-light;
        }
      }

      &-form {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        width: 18vw;
        min-width: 190px;
        max-width: 350px;
        // margin-left: 10.5vw;

        h5 {
          display: block;
          margin: 0 0 30px;
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 300;
          font-size: 18px;
          line-height: 30px;
          color: $color-light;
        }

        .ask-us {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          input:not([type="checkbox"]):not([type="submit"]),
          select,
          textarea,
          label,
          button {
            display: block;
            width: 100%;
            margin-bottom: 12px;
            font-family: "Poppins", sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 18px;
            letter-spacing: 0.2em;
            text-transform: uppercase;
            color: $color-yellow;
            border: 1px solid $color-yellow;
            border-radius: 80px;
            background: transparent;
            outline: none;
          }

          input {
            padding: 7px 15px;
            height: 45px;

            @media screen and (max-width: 768px) {
              height: 35px;
            }
          }

          input[name="user_name"] {
            text-transform: capitalize;
          }

          .select-wrapper {
            display: block;
            width: 100%;
            margin-bottom: 12px;
            padding: 0 9px;
            border: 1px solid $color-yellow;
            border-radius: 80px;
            background: transparent;
          }

          select {
            margin: 0;
            padding: 7px 15px;
            height: 45px;
            border: 0px;
          }

          textarea {
            height: 80px;
            padding: 7px 15px;
            border-radius: 20px;

            @media screen and (max-width: 768px) {
              min-height: 60px;
            }
          }

          ::-webkit-input-placeholder {
            /* Edge */
            color: $color-yellow;
          }

          :-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: $color-yellow;
          }

          ::placeholder {
            color: $color-yellow;
          }

          button {
            display: inline-block;
            width: auto;
            margin: 0 0 0 auto;
            padding: 7px 15px;

            &:hover {
              cursor: pointer;
              background-color: $color-yellow;
              color: $color-dark;
            }
          }

          input[type="submit"] {
            background: linear-gradient(
              to right,
              $color-yellow 50%,
              transparent 50%
            );
            background-size: 200% 100%;
            background-position: right bottom;
            // transition: all 0.3s ease-out;

            @media (hover: hover) {
              &:hover {
                background-color: $color-yellow;
              }
            }

            &.loading {
              animation-duration: 1s;
              animation-name: animateButton;
              animation-iteration-count: infinite;
              animation-direction: alternate;
            }

            @keyframes animateButton {
              from {
                background-position: right bottom;
                color: inherit;
              }

              to {
                background-position: left bottom;
                color: $color-dark;
              }
            }
          }
        }
      }
    }
  }
  // }
}

.social-footer {
  position: relative;
  z-index: 120;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 120px auto;

  &-wrapper {
    display: block;
    width: 230px;
  }

  &-network {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    width: 100%;
  }

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      cursor: pointer;
    }
  }

  span {
    display: block;
    margin-top: 18px;
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    letter-spacing: -0.015em;
    color: $color-dark;
    text-align: center;

    &:last-child {
      opacity: 0.8;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .margintop {
    margin-top: -30vh;
  }

  .mask-right {
    -webkit-mask-size: 140vw 90vh;
    mask-size: 140vw 90vh;
    -webkit-mask-position: -40vw 50px;
    mask-position: -40vw 50px;

    &.active {
      -webkit-mask-position: -40vw 50px;
      mask-position: -40vw 50px;
    }
  }

  .appointment-cta {
    a {
      &:after {
        content: "";
      }
    }
  }

  .home {
    &-hero {
      height: 90vh;
      margin-bottom: 0;

      &.mask-right {
        webkit-mask-position: -40vw 0;
        mask-position: -40vw 0;
      }

      &-content {
        h3,
        h2 {
          width: 80vw;
        }

        h2 {
          text-align: center;
        }
      }
    }

    .section-wrapper {
      height: calc(100vh - 65px);

      > div:not(.social-footer) + div {
        top: 0;
      }

      &--projects {
        height: 640px;
        margin-top: 0;

        .button--map {
          top: -100px;
        }
      }

      &--footer {
        height: 140vh;
      }

      h2 {
        margin: 100px auto 0;
      }
    }

    .our-projects {
      height: 150vh;

      &-wrapper {
        height: auto;
        padding-top: 150px;
      }

      &-map {
        top: 150px !important;
        height: 60vh;

        &.visible {
          transform: translate3d(0, 0, 0);
        }
      }

      &.mask-right {
        pointer-events: none;
      }

      &-block {
        width: calc(100% / 3);
        margin-top: -30px;

        &:nth-child(2) {
          margin-top: -30px;

          .our-projects-block-title {
            margin-top: -80px;
          }
        }

        &:nth-child(3) {
          margin-top: -30px;

          .our-projects-block-title {
            margin-top: -70px;
          }
        }

        &-title {
          margin-top: -60px;
          padding: 10px 30px;

          span {
            font-size: 10px;
          }
        }

        h4 {
          font-size: 20px;
        }

        svg {
          transform: scale(0.4);
        }
      }
    }

    .about-us {
      background-size: auto;
      background-position: center center;

      &-shadow {
        height: 89vh;
      }

      &-content {
        margin-top: 130px;

        &.mt180 {
          margin-top: 150px;
        }
      }
    }

    .subsection-wrapper {
      .shape {
        width: 60vw;
        height: 200px;
        margin-top: -40px;
        border-radius: 104px;

        &--notitle {
          margin-top: 180px;
        }

        &.short {
          margin: -20px auto -150px;
        }
      }

      h3 {
        width: 46vw;
        font-size: 24px;
        line-height: 30px;
      }

      p {
        width: 46vw;
        max-width: 46vw;
        font-size: 12px;
        line-height: 18px;
      }
    }

    .footer {
      height: 140vh;

      &.mask-right {
        -webkit-mask-size: 140vw 1000px;
        mask-size: 140vw 1000px;
      }
    }

    .footer-wrapper {
      flex-direction: column;
      height: auto;

      &-text {
        width: 40vw;
        margin: 0 auto;

        h4 {
          width: 40vw;
          margin: 20px auto;
          font-size: 23px;
          line-height: 29px;
          text-align: center;
        }

        p {
          font-size: 12px;
          line-height: 18px;
          text-align: justify;
        }
      }

      &-form {
        width: 80vw;
        margin: 20px auto 0;

        h5 {
          display: block;
          width: 100%;
          font-size: 15px;
          text-align: center;
        }
      }
    }

    .social-footer {
      margin: 20px auto;
    }
  }
}

@media screen and (max-width: 760px) {
  .home {
    &-hero {
      margin-bottom: 0;
      background-image: url("~@/assets/content/hero-m.gif");
      background-size: cover;
      background-position: center center;
      background-repeat: none;

      video {
        display: none;
      }

      &.mask-right {
        -webkit-mask-position: right -20vh;
        mask-position: right -20vh;
      }

      &-content {
        h3,
        h2 {
          width: 80vw;
        }

        h3 {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 600;
          font-size: 10px;
          line-height: 15px;
          letter-spacing: 0.2em;
        }

        h2 {
          font-family: "gopherbold";
          font-style: normal;
          font-size: 35px;
          line-height: 35px;
          text-align: center;
        }

        a {
          padding: 13px 11px;
          font-size: 10px;
          line-height: 12px;
          border-radius: 44px;
        }
      }
    }

    .section-wrapper {
      height: calc(100vh - 65px);
      margin-top: -48px;
      z-index: 90;

      > div:not(.social-footer) + div {
        // top: -100px;
        top: 0;
      }

      &--projects {
        &.section-wrapper--epos {
            height: 520px;
        }

        height: 960px;

        .button--map {
          &--d {
            display: none;
          }

          &--m {
            position: relative;
            top: 18px;
            left: -50px;
            height: 48px;
            padding: 0 50px;
            font-size: 0;
            background-color: $color-yellow;
            z-index: 100;

            &:after {
              content: "";
              position: absolute;
              top: 5px;
              right: 15px;
              display: block;
              width: 32px;
              height: 32px;
              background-image: url("~@/assets/nearby-pin.svg");
              background-color: $color-yellow;
              background-repeat: no-repeat;
              background-size: contain;
              background-position: center center;
            }
          }
        }
      }

      &--footer {
        height: 1140px;
      }

      &.mt190 {
        margin-top: -90px;
      }

      &.mt120 {
        margin-top: -100px;
      }

      h2 {
        margin: 50px auto 0;
        font-size: 12px;
        line-height: 18px;
      }

      .single-img {
        height: calc(100vh - 65px);
      }
    }

    .our-projects {
      height: 150vh;

      &.mask-right {
        -webkit-mask-size: 1920px 1040px;
        mask-size: 1920px 1040px;
      }

      &-wrapper {
        flex-direction: column;
        height: auto;
        padding-top: 90px;
      }

      &-block {
        margin-top: -30px;

        &:nth-child(2) {
          margin-top: -30px;

          .our-projects-block-title {
            margin-top: -80px;
          }
        }

        &:nth-child(3) {
          margin-top: -30px;

          .our-projects-block-title {
            margin-top: -70px;
          }
        }

        &-title {
          margin-top: -60px;
          padding: 10px 30px;

          span {
            font-size: 10px;
          }
        }

        h4 {
          font-size: 20px;
        }

        svg {
          transform: scale(0.4);
        }
      }
    }

    .about-us {
      background-position: center 0;

      &-shadow {
        height: 89vh;
      }

      &-content {
        margin-top: 200px;

        &.mt180 {
          margin-top: 180px;
        }
      }
    }

    .subsection-wrapper {
      margin-bottom: 60px;

      .shape {
        width: 80vw;
        height: 120px;
        margin-top: 0;
        border-radius: 64px;

        &--withtitle {
          margin-top: 40px;
        }

        &--notitle {
          margin-top: 170px;
        }

        &.short {
          margin: -20px auto -150px;
        }
      }

      h3 {
        width: 66vw;
        font-size: 24px;
        line-height: 30px;
      }

      p {
        width: 66vw;
        max-width: 66vw;
        font-size: 12px;
        line-height: 18px;
      }
    }

    .footer {
      height: 1000px;

      &.mask-right {
        -webkit-mask-size: 1920px 1080px;
        mask-size: 1920px 1080px;
      }
    }

    .footer-wrapper {
      flex-direction: column;
      margin-top: 120px;

      &-text {
        width: 80vw;
        margin: 0 auto;

        h4 {
          width: 70%;
          margin: 0 auto;
          font-size: 23px;
          line-height: 29px;
          text-align: center;
        }

        p {
          font-size: 12px;
          line-height: 18px;
          text-align: justify;
        }
      }

      &-form {
        width: 80vw;
        margin: 0 auto;

        h5 {
          display: block;
          width: 100%;
          margin: 10px 0 10px;
          font-size: 15px;
          text-align: center;
        }
      }
    }

    .social-footer {
      margin: 20px auto;
    }

    .call-us {
      display: block;
      width: 100%;
      margin-bottom: 10px;
      text-align: center;

      h5 {
        margin: 0;
        color: $color-yellow;
      }

      a {
        margin: 5px 0 20px 0 !important;
        font-size: 10px;
        color: $color-dark;
        background: $color-yellow;
      }
    }
  }
}

@media screen and (min-width: 760px) {
  .appointment-cta {
    position: fixed;
    top: 55vh;
    right: 0;
    display: block;
    max-width: 175px;
    padding: 13px 26px;
    background: $color-yellow;
    border-radius: 31px 0 0 31px;
    z-index: 91;
    transform: translate3d(10px, 0, 0);
    transition: transform 0.3s ease;

    &:hover {
      cursor: pointer;
      transform: translate3d(0, 0, 0);

      a {
        transform: translate3d(10px, 0, 0);
      }
    }

    a {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      align-items: center;
      letter-spacing: 0.2em;
      text-transform: uppercase;
      text-decoration: none;
      color: $color-dark;
      transform: translate3d(0, 0, 0);
      transition: transform 0.3s ease;
    }
  }

  .section-wrapper {
    &--projects {
      .button--map {
        &--d {
          display: inline-block;
        }

        &--m {
          display: none;
        }
      }
    }
  }

  .home .our-projects-map {
    top: 210px !important;
  }
}
</style>
